import Helper from "./Helper";

class Navigation {
  constructor(config = {}) {
    const { menuTogglerSelector, menuTogglerMobileSelector, backdropClass, openButtonSelector, togglingContainerSelector } = config;
    this.body = document.querySelector("body");
    this.backdropClass = backdropClass || "menu-backdrop";
    this.menuToggler = document.querySelector(menuTogglerSelector);
    this.menuTogglerMobile = document.querySelector(menuTogglerMobileSelector);
    this.openButton = document.querySelector(openButtonSelector);
    this.togglingContainer = document.querySelector(togglingContainerSelector);
    this.togglerArray = Array.prototype.slice.call(
      document.querySelectorAll(".menu__link--level-1")
    );
    this.lvl0Array = Array.prototype.slice.call(
      document.querySelectorAll(".menu__link--level-0")
      );
    this.backArray = Array.prototype.slice.call(document.querySelectorAll('.menu__item-back'));

    this.metaBindEvents();

    if (this.menuToggler) {
      this.bindEvents();
      this.addBackdrop();
      // this.addFloatingLine(document.querySelector(".header__inner>div"));
      this.addFloatingLine(document.querySelector(".menu--level-1"));
      this.setActiveClasses();
    }
  }

  addBackdrop() {
    let backdrop = document.querySelector(`.${this.backdropClass}`);
    if (!backdrop) {
      backdrop = document.createElement("div");
      Helper.addClass(backdrop, this.backdropClass);
      this.body.appendChild(backdrop);
    }
  }

  metaBindEvents() {
    this.openButton.addEventListener('click', () => {
      console.log('search-clicked');
      Helper.toggleClass(this.togglingContainer, 'active');
      Helper.toggleClass(this.body, 'search-open');
      Helper.toggleClass(this.menuToggler, 'search-active');
      Helper.toggleClass(this.menuTogglerMobile, 'search-active');
    });
  }

  bindEvents() {
    window.addEventListener('resize', () => {
      this.setActiveClasses();
    });

    this.menuToggler.addEventListener("click", e => {
      e.preventDefault();
      if(Helper.hasClass(this.menuToggler, 'search-active')){
        Helper.removeClass(this.togglingContainer, 'active');
        Helper.removeClass(this.body, 'search-open');
        Helper.removeClass(this.menuToggler, 'search-active');
      } else {
        this.toggleMenu(document.querySelector(`.${this.backdropClass}`));
      }
    });

    if ( typeof this.menuTogglerMobile !== undefined && this.menuTogglerMobile !== null ) {
      this.menuTogglerMobile.addEventListener("click", e => {
        if(Helper.hasClass(this.menuTogglerMobile, 'search-active')){
          Helper.removeClass(this.togglingContainer, 'active');
          Helper.removeClass(this.body, 'search-open');
          Helper.removeClass(this.menuTogglerMobile, 'search-active');
        } else {
          this.toggleMenu(document.querySelector(`.${this.backdropClass}`));
        }
      });
    }

    // this is a checkbox added via livingdocs
    if(document.querySelector('.open-navigation')){
      document.querySelector('.open-navigation').addEventListener('click', e => {
        e.preventDefault();
        if(Helper.hasClass(this.menuToggler, 'search-active') || Helper.hasClass(this.menuTogglerMobile, 'search-active')){
          Helper.removeClass(this.togglingContainer, 'active');
          Helper.removeClass(this.body, 'search-open');
          Helper.removeClass(this.menuToggler, 'search-active');
          Helper.removeClass(this.menuTogglerMobile, 'search-active');
        } else {
          this.toggleMenu(document.querySelector(`.${this.backdropClass}`));
        }
      });
    }

    this.backArray.forEach((toggler, index) => {
      toggler.addEventListener("click", e => {
        Helper.removeClass(toggler.parentElement.parentElement, 'submenu-open');
      });
    });

    this.togglerArray.forEach((toggler, index) => {
      toggler.addEventListener("click", e => {
        this.toggleActive(toggler, this.togglerArray);
        this.toggleSubmenu(toggler, ".menu--level-2");
      });

      toggler.addEventListener("mouseenter", e => {
        this.positionFloater(toggler);
      });
      toggler.addEventListener("mouseleave", e => {
        if (document.querySelector(".menu__link--level-1.active")) {
          this.positionFloater(document.querySelector(".menu__link--level-1.active"));
        } else {
          this.positionFloater(document.querySelector(".menu__link--level-1"), true);
        }
      });
    });

    this.lvl0Array.forEach(toggler => {
      toggler.addEventListener("mouseenter", e => {
        this.positionFloater(toggler);
      });
      toggler.addEventListener("mouseleave", e => {
        if (document.querySelector(".menu__link--level-0.active")) {
          this.positionFloater(document.querySelector(".menu__link--level-0.active"));
        } else {
          this.positionFloater(document.querySelector(".menu__link--level-0"),true);
        }
      });
    });
  }

  toggleActive(activeToggle, togglerArray) {
    togglerArray.forEach(item => {
      if (item !== activeToggle) {
        Helper.removeClass(item, "active");
      }
    });
    Helper.addClass(activeToggle, "active");
    this.positionFloater(activeToggle);
    this.addBackLink(activeToggle);
  }

  addBackLink(activeToggle){
    let checkItem = document.querySelector('.ns-header__breadcrump');
    if(checkItem){
      return
    }
    //get content of backLink
    let subarray = activeToggle.parentNode.querySelectorAll('.menu__item--level-2');
    let linkText = activeToggle.textContent;
    let link = subarray.length > 0 ? subarray[0].querySelector('a').getAttribute("href") : this.lvl0Array[0].getAttribute("href");

    //if the main-link with level 1 has no children, back-link has to contain the element of the parent (level-0 of navigation)
    if(Helper.hasClass(activeToggle, 'menu__item--level-1') && Helper.hasClass(activeToggle, 'menu__item--has-no-children')) {
      linkText = this.lvl0Array[0].textContent;
      link = this.lvl0Array[0].getAttribute("href");
    }

    //if it's the first element in second-level navigation, back-link has to contain the element of the parent (level-0 of navigation)
    if(subarray[0] && Helper.hasClass(subarray[0], 'menu__item--active')) {
      linkText = this.lvl0Array[0].textContent;
      link = this.lvl0Array[0].getAttribute("href");
    }

    //creat elements for link
    let container = document.createElement('div');
    let anchor = document.createElement('a');
    let spanInner = document.createElement('span');
    let spanText = document.createElement('span');
    Helper.addClass(container, 'ns-header__breadcrump');
    Helper.addClass(anchor, 'ns-header__back-link');
    anchor.setAttribute('href', link); //add Link from parent of active menu-link
    spanText.innerHTML = linkText; //add Linktext from parent of active menu-link
    Helper.addClass(spanInner, 'menu-back-icon');
    spanInner.innerHTML = '<svg class="arrow-back" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M13.7 30.4l1.4-1.4-4.3-4.3h25.274v-2H10.8l4.3-4.3-1.4-1.4L7 23.7z"></path></svg>';
    anchor.appendChild(spanInner);
    anchor.appendChild(spanText);
    container.appendChild(anchor); //build it!

    const title = document.querySelector('.ns-header');
    if(title) {
      title.prepend(container);
    }
  }

  toggleSubmenu(toggler, Lvl2Selector) {
    // console.log('toggle submneu');
    const lvl2 = Array.prototype.slice.call(
      document.querySelectorAll(Lvl2Selector)
    );
    lvl2.forEach(item => {
      if (item !== toggler.parentElement.querySelector(Lvl2Selector)) {
        item.classList.remove("submenu-open");
      }
    });
    Helper.addClass(toggler.parentElement.querySelector(Lvl2Selector),"submenu-open");
  }

  toggleMenu(backdrop) {
    // console.log('toggle menu');
    Helper.toggleClass(this.body, "menu-open");
    Helper.toggleClass(this.menuToggler, "burger-active");
    Helper.toggleClass(this.menuTogglerMobile, "burger-active");
    // Helper.toggleClass(backdrop, 'menu-open');
  }

  addFloatingLine(selector) {
    const floater = document.createElement("i");
    Helper.addClass(floater, "floating-hover");
    selector.appendChild(floater);
  }

  setActiveClasses() {
    // console.log('set active');
    const lvl2active = document.querySelector(".menu__item--level-2.menu__item--active");
    if (lvl2active) {
      // console.log('has active lvl 2');
      Helper.addClass(lvl2active.parentElement.parentElement, "submenu-open");
      this.toggleActive(lvl2active.parentElement.parentElement.previousElementSibling,this.togglerArray);
    }
    if (document.querySelector(".menu__item--level-1.menu__item--active")) {
      this.toggleActive(document.querySelector(".menu__item--level-1.menu__item--active"),this.togglerArray);
    }
    if (document.querySelector(".menu__item--level-0.menu__item--ancestor-active") || document.querySelector(".menu__item--level-0.menu__item--active")) {
      // console.log('level 0 is active');
      if (document.querySelector(".menu__item--level-0.menu__item--active .menu__link")) {
        Helper.addClass(document.querySelector(".menu__item--level-0.menu__item--active .menu__link"),"active");
      }
      if (document.querySelector(".menu__item--level-0.menu__item--ancestor-active .menu__link")) {
        Helper.addClass(document.querySelector(".menu__item--level-0.menu__item--ancestor-active .menu__link"),"active");
      }
      // this.positionFloater(document.querySelector(".menu__link--level-0.active"));
    }
  }

  positionFloater(elementToFloatto, reset = false) {
    let floater;
    if (elementToFloatto.closest(".menu__inner")) {
      floater = elementToFloatto.closest(".menu__inner").nextElementSibling;
    }
    if (!Helper.hasClass(floater, "is-visible")) {
      Helper.addClass(floater, "is-visible");
    }
    floater.style.left = `${elementToFloatto.getBoundingClientRect().left}px`;
    if (reset) {
      floater.style.left = "-100%";
      Helper.removeClass(floater, "is-visible");
    }
  }
}

export default Navigation;
